<template>
<b-container>
<h3>Pour recevoir votre réponse personnalisée, merci d'indiquer les informations suivantes:</h3>
    <b-form-group

    label="Votre nom"
    label-for="name"
  >
  <b-form-input id="name" v-model.trim="name"></b-form-input>

  </b-form-group>
  <b-form-group

    label="Votre prénom"
    label-for="firstname"
  >
  <b-form-input id="firstname" v-model.trim="firstname"></b-form-input>

  </b-form-group>

  <b-form-group

    label="Votre email"
    label-for="email"
  >
  <b-form-input id="email" type="email" v-model.trim="email"></b-form-input>

  </b-form-group>

    <b-form-group class="text-center">
  <b-button v-animate-css="{classes: 'shake', delay: 3000}"  variant="primary" @click="saveAnswers">Recevoir Mon Profil</b-button>
</b-form-group>

      </b-container>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { db } from '../main'
import firebase from 'firebase/app'
  export default {
    name: 'answer',

    computed: {
    // When using nested data structures, the string
    // after the last dot (e.g. `firstName`) is used
    // for defining the name of the computed property.
    ...mapFields([
      'answers.name',
      'answers.firstname',
      'answers.email',
      'answers',
    ]),
  },
  // firestore () {
  //   return {
  //     answers: db.collection('answers')
  //   }
  // },
  methods: {
    saveAnswers () {      // <-- and here
      // console.log(this.$store.getAnswersField())
      db.collection('answers').doc(this.answers.email).set({...this.answers, createdAt: firebase.firestore.FieldValue.serverTimestamp()})
      this.$router.push({ path: '/thankyou' })

    }
  }
  }
</script>

<style scoped>

</style>